import src from "IMAGE";
export default { src, width: 168, height: 191, blurWidth: 0, blurHeight: 0};
